import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import TRANSLATIONS_DE from "./de/translation.json";
import TRANSLATIONS_EN from "./en/translation.json";
import TRANSLATIONS_I18N from "./i18n/translation.json";
//import {getCookie} from "Services/utils";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    //debug:true,
    parseMissingKeyHandler: (key, defaultValue) => {
        return process.env.NODE_ENV === 'development' ? key : defaultValue;
    },
    
    //overloadTranslationOptionHandler:args => {return { defaultValue: '' }}, //Used for all keys
    lng: document.getElementById('ReactBooking')?.getAttribute("data-lang") ?? "en",
    supportedLngs:  process.env.NODE_ENV === 'development' ?  ['en', 'de', 'i18n'] :  ['en', 'de'],
    fallbackLng: "de",// use en if detected lng is not available
    resources: {
		en: {translation: TRANSLATIONS_EN},
		de: {translation: TRANSLATIONS_DE},
		i18n: {translation: TRANSLATIONS_I18N}
    },
    interpolation: {
		format: function (value, format, lng) {
			if (value instanceof Date) return moment(value).format(format);
			if (typeof value === "number")
				return new Intl.NumberFormat(lng).format(value);
			return value;
		},
		escapeValue: false,
    },
});

export { i18n };
